import React, { useState } from "react";
import Popover, { ArrowContainer } from "react-tiny-popover";

import Icon from "../Icon";

const MedicationsInfo = () => {
  const [showInfo, setShowInfo] = useState(false);

  const Info = ({ position, targetRect, popoverRect }) => {
    return (
      <ArrowContainer
        position={position}
        targetRect={targetRect}
        popoverRect={popoverRect}
        arrowColor={"#404040"}
      >
        <div className="Tooltip-text" role="alert" aria-live="polite">
          <p>
            The PAN Foundation covers all prescription medications for each
            diagnosis, including generic or bioequivalent drugs, that meet any
            of the following criteria:
          </p>
          <ul>
            <li>FDA-approved</li>
            <li>Listed in official compendia</li>
            <li>Listed in published evidence-based or clinical guidelines</li>
          </ul>
        </div>
      </ArrowContainer>
    );
  };

  return (
    <Popover
      isOpen={showInfo}
      position={["bottom", "top"]}
      onClickOutside={() => setShowInfo(false)}
      content={({ position, targetRect, popoverRect }) => (
        <Info
          position={position}
          targetRect={targetRect}
          popoverRect={popoverRect}
        />
      )}
    >
      <button
        type="button"
        className="btn-reset"
        onClick={() => setShowInfo(!showInfo)}
      >
        <Icon className="Tabs-infoIcon" name="infoCircle" width="20" height="20" />
        <span className="u-screenreader">What does this mean?</span>
      </button>
    </Popover>
  );
};

export default MedicationsInfo;
